const AddIcon =  ({
  height = "16px",
  width = "16px",
}: {
  height?: string;
  width?: string;
}) => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: `${width}`, height: `${height}` }} // Use inline styles here

        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_590_4993)">
          <mask
            id="mask0_590_4993"
            mask-type="luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="16"
          >
            <path d="M16 0H0V16H16V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_590_4993)">
            <path
              d="M8 0C3.58853 0 0 3.58853 0 8C0 12.4115 3.58853 16 8 16C12.4115 16 16 12.4108 16 8C16 3.58916 12.4115 0 8 0ZM8 14.7607C4.27266 14.7607 1.23934 11.728 1.23934 8C1.23934 4.27203 4.27266 1.23934 8 1.23934C11.7273 1.23934 14.7607 4.27203 14.7607 8C14.7607 11.728 11.728 14.7607 8 14.7607Z"
              fill="#183883"
            />
            <path
              d="M11.0982 7.32494H8.61949V4.84625C8.61949 4.50419 8.34249 4.22656 7.9998 4.22656C7.65711 4.22656 7.38011 4.50419 7.38011 4.84625V7.32494H4.90142C4.55874 7.32494 4.28174 7.60256 4.28174 7.94462C4.28174 8.28669 4.55874 8.56431 4.90142 8.56431H7.38011V11.043C7.38011 11.3851 7.65711 11.6627 7.9998 11.6627C8.34249 11.6627 8.61949 11.3851 8.61949 11.043V8.56431H11.0982C11.4409 8.56431 11.7179 8.28669 11.7179 7.94462C11.7179 7.60256 11.4409 7.32494 11.0982 7.32494Z"
              fill="#183883"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_590_4993">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};
export default AddIcon;
